export const apiApproveOrder = id => `/1.0/wsm/history/warehouse/${id}/browse`
export const apiRejectOrder = id => `/1.0/wsm/history/warehouse/${id}/refuse`
export const apiExportExcel = "1.0/wsm/history/warehouse/export"
export const apiExportExcelReport = "1.0/wsm/report/order/export"
export const apiReceiveOrder = id => `/1.0/wsm/history/warehouse/${id}/received`
export const apiPurchaseOrder = id => `/1.0/wsm/history/warehouse/${id}/completed/purchase`